var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { class: { "vs-logo--no-margin": _vm.noMargin } }, [
    _vm.cobrandLogo
      ? _c(
          "div",
          { staticClass: "sm_ml-0", class: _vm.cart.qty ? "-ml-4" : null },
          [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.cobrandLogo,
                  expression: "cobrandLogo"
                }
              ],
              key: _vm.cobrandLogo,
              staticClass: "h-1_5 md_h-2 lg_h-2_75",
              attrs: { alt: "partner logo", "aria-label": "partner logo" }
            })
          ]
        )
      : _vm.$mq === "sm" || _vm.$mq === "md"
      ? _c(
          "svg",
          {
            staticClass: "h-2_75",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 94.349997 86.700001"
            }
          },
          [
            _c("path", {
              staticClass: "text-brand-secondary fill-current",
              attrs: {
                d:
                  "m 24.712404,40.37347 15.56928,14.688 c 0.4896,0.4896 0.78336,1.37088 1.07712,2.05632 1.9584,5.8752 4.01472,11.7504 5.58144,16.45056 4.896,-17.03808 10.08576,-35.05536 15.27552,-53.3664 5.3856,1.9584 10.57536,3.81888 16.05888,5.67936 1.9584,-4.896 3.81888,-9.596159 5.77728,-14.590077 l -14.1984,-7.7356762 23.79456,7.1481572 c -3.62304,8.323196 -7.14816,16.548476 -10.86912,24.871676 -6.3546,-1.7136 -6.3546,-1.7136 -11.45664,-3.13344 -5.975074,17.73964 -12.116483,36.48422 -17.136,51.8976 -0.4896,1.468797 -1.17504,1.860477 -2.64384,1.860477 -3.23136,-0.0979 -6.46272,0 -9.59616,-0.0979 -0.58752,0 -1.478606,-0.17392 -1.76256,-0.979197 C 34.016777,67.63374 28.398118,51.12113 24.712404,40.37347 Z"
              }
            }),
            _c("path", {
              staticClass: "text-brand fill-current",
              attrs: {
                d:
                  "m 39.664187,48.5879 c -5.216047,-4.76286 -10.8566,-9.88477 -15.386,-14.112 -0.98,-0.882 -1.764,-1.078 -2.94,-0.686 -3.234,0.98 -6.37,1.862 -9.898,2.744 C 7.9121875,28.3999 4.3841875,20.3639 0.66018746,12.131903 8.6437511,8.4521464 17.38625,4.6609067 24.474187,1.645907 c 1.47,-0.588 3.136,-0.88200012 4.704,-0.98000012 3.234,-0.196 6.468,0 9.8,0 0.784,4.99799972 2.548,9.40799712 8.428,9.79999712 4.116,0.294 7.35,-2.5479976 9.31,-7.6439971 1.078,5.1939995 -2.548,10.8779951 -7.644,12.7399941 -6.664,2.449999 -13.328,0.196 -16.17,-5.6839966 -2.94,-0.2939985 -5.684,0 -8.33,1.3719986 -3.92,1.959999 -8.134,3.625998 -12.25,5.487998 1.078,2.841999 2.156,5.585999 3.332,8.231999 0.196,0.392 1.274,0.784 1.764,0.686 4.214,-1.078 8.526,-2.254 12.74,-3.528 1.47,-0.392 2.058,-0.294 2.45,1.274 3.332,12.446 3.332,12.446 7.056,25.186 z"
              }
            })
          ]
        )
      : _c(
          "svg",
          {
            staticClass: "h-2_75",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 365.5 102.2"
            }
          },
          [
            _c("path", {
              staticClass: "fill-current text-brand-secondary",
              class: { "vs-logo__secondary--white": _vm.color === "white" },
              attrs: {
                d:
                  "M261.5 102.2c2.4-5.7 4.6-11 6.8-16.3.3-.8.3-1.8 0-2.6-3.9-10-7.9-20.1-11.8-30.1-.4-1.2-.9-1.7-2.2-1.6-1.9.1-3.7 0-5.9 0v35.2h-13.8V51.6H228V41.1h6.5V25.9h13.8V41h14c4.3 0 4.3 0 5.7 4.1l7.2 20.7c.1.4.3.8.7 1.6 2.3-7 4.5-13.6 6.7-20.1.7-2.1.9-4.9 2.4-6 1.4-1 4.1-.3 6.3-.3h8.1c-1.2 3.2-2.3 6.2-3.5 9.2-6.3 16.7-12.6 33.3-18.9 50-.5 1.4-1.1 2-2.7 1.9-4.1 0-8.3.1-12.8.1z"
              }
            }),
            _c("path", {
              staticClass: "fill-current text-brand",
              attrs: {
                d:
                  "M153.4 86.7v-4.4c-7 8.9-21.2 6.9-28.1 1.2-11.5-9.5-11.8-31.3 1.7-40.1 5.5-3.6 11.5-4.8 18-3.2 3.3.8 6 2.6 8.3 5.7v-4.7H167v45.5h-13.6zM142 75.6c6.5 0 11.4-5 11.4-11.7 0-6.6-5-11.6-11.5-11.6-6.4 0-11.4 5.1-11.4 11.8.1 6.5 5.2 11.5 11.5 11.5z"
              }
            }),
            _c("path", {
              staticClass: "fill-current text-brand-secondary",
              class: { "vs-logo__secondary--white": _vm.color === "white" },
              attrs: {
                d:
                  "M365.1 68.2H331c.6 6.5 7.1 9 11.5 8.5 2.6-.3 4.7-1.4 6.4-3.3.4-.4 1.1-.9 1.6-.9 4-.1 7.9 0 11.9 0 .4 0 .8.1 1.2.1C361 81.1 350.3 90.7 337 88c-13.9-2.8-21.2-15.3-19.7-26.8C319.2 46.9 332 37.3 346 40c12.9 2.4 21.5 15 19.1 28.2zm-13.6-9.5c-.8-4.5-5.2-7.6-10.4-7.5-5 .1-9.1 3.2-9.8 7.5h20.2z"
              }
            }),
            _c("path", {
              staticClass: "fill-current text-brand",
              attrs: {
                d:
                  "M23.9 40.2l15.9 15c.5.5.8 1.4 1.1 2.1 2 6 4.1 12 5.7 16.8 5-17.4 10.3-35.8 15.6-54.5 5.5 2 10.8 3.9 16.4 5.8 2-5 3.9-9.8 5.9-14.9-5-2.4-9.8-5-14.6-7.5 0-.1.1-.3.1-.4C78 5 86 7.4 94.3 9.9c-3.7 8.5-7.3 16.9-11.1 25.4-3.9-1.1-7.7-2.1-11.7-3.2-.3.8-.5 1.5-.8 2.2-5.6 17-11.2 33.9-16.7 50.8-.5 1.5-1.2 1.9-2.7 1.9-3.3-.1-6.6 0-9.8-.1-.6 0-1.6-.5-1.8-1C34.3 70.8 29 55.6 23.6 40.5l.3-.3z"
              }
            }),
            _c("path", {
              staticClass: "fill-current text-brand-secondary",
              class: { "vs-logo__secondary--white": _vm.color === "white" },
              attrs: {
                d:
                  "M191.6 73.2c4.4 0 8.6 0 12.7.1.5 0 1.2.7 1.4 1.2 1.3 3.6 6.9 3.4 8.7 1.5 1.3-1.4 1.3-3.3-.3-4.6-1.2-.9-2.6-1.6-4-2.1-2.6-1-5.2-1.9-7.9-2.9-.7-.3-1.5-.6-2.2-.9-10.8-5-9.1-16-2.8-21.4 7.5-6.4 20.4-5.9 26.9 1.1 2 2.2 3 4.6 3.6 8.9h-12.8c-.3 0-.7-.6-.9-1-1.2-2.4-4.8-3.1-6.8-1.4-1.5 1.3-1.5 3.3.4 4.4 2 1.2 4.3 2 6.6 2.8 2.6 1 5.3 1.7 7.9 2.8 8.8 3.8 8.7 14.1 4.7 19.5-4.7 6.4-11.5 7.9-18.9 7.2-4.5-.4-8.7-2-11.9-5.5-2.7-2.7-3.8-5.9-4.4-9.7zM39.8 49c-.9-.8-1.3-1.2-1.8-1.6-4.6-4.3-9.3-8.5-13.9-12.8-1-.9-1.8-1.1-3-.7-3.3 1-6.5 1.9-10.1 2.8-3.6-8.3-7.2-16.5-11-24.9.9-.4 1.7-.8 2.5-1.2C9.8 7.4 17 4.2 24.3 1.1c1.5-.6 3.2-.9 4.8-1 3.3-.2 6.6 0 10 0 .8 5.1 2.6 9.6 8.6 10 4.2.3 7.5-2.6 9.5-7.8 1.1 5.3-2.6 11.1-7.8 13-6.8 2.5-13.6.2-16.5-5.8-3-.3-5.8 0-8.5 1.4-4 2-8.3 3.7-12.5 5.6 1.1 2.9 2.2 5.7 3.4 8.4.2.4 1.3.8 1.8.7 4.3-1.1 8.7-2.3 13-3.6 1.5-.4 2.1-.3 2.5 1.3 2.2 8 4.5 16 6.8 24 .2.4.2.8.4 1.7z"
              }
            }),
            _c("path", {
              staticClass: "fill-current text-brand",
              attrs: { d: "M172.9 26h13.4v60.8h-13.4V26z" }
            }),
            _c("path", {
              staticClass: "fill-current text-brand-secondary",
              class: { "vs-logo__secondary--white": _vm.color === "white" },
              attrs: { d: "M313.8 86.8h-13.5V25.9h13.5v60.9z" }
            }),
            _c("path", {
              staticClass: "fill-current text-brand",
              attrs: {
                d:
                  "M93.1 86.8V41.2h12.8v4c2.9-4.1 6.8-5.6 11.7-5.6 0 4.4 0 8.7-.1 12.9 0 .3-.8.8-1.2.9-1.2.2-2.4.2-3.6.5-4 .8-5.9 3.1-5.9 7.1-.1 7.8 0 15.7 0 23.5v2.3H93.1zM87.5 86.9H75.3c-.4 0-.8 0-1.3-.1V41.3h13.5v45.6z"
              }
            })
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }